import React, { useContext } from "react";
import { useKeycloak } from "@react-keycloak/web";
import { useMediaQuery, useTheme } from "@material-ui/core";
import {
  HvHeader,
  HvHeaderBrand,
  HvHeaderActions,
  HvButton,
} from "@hitachivantara/uikit-react-core";
import { ThemeSwitcher, Menu, LogOut } from "@hitachivantara/uikit-react-icons";
import { ThemeContext } from "lib/context/ThemeContext";
import { NavigationContext } from "lib/context/NavigationContext";
import { HitachiLogo } from "assets/HitachiLogo";
import useStyles from "./styles";

const Header: React.FC = () => {
  const theme = useTheme();
  const classes = useStyles();
  const { keycloak } = useKeycloak();
  const { toggleTheme } = useContext(ThemeContext);
  const { toggleVerticalOpen } = useContext(NavigationContext);
  const isMdUp = useMediaQuery(theme.breakpoints.up("md"));
  const production = process.env.NODE_ENV === "production";

  return (
    <HvHeader>
      {!production && !isMdUp && (
        <div>
          <HvButton category="ghost" icon onClick={toggleVerticalOpen}>
            <Menu />
          </HvButton>
        </div>
      )}

      <HvHeaderBrand
        className={classes.brand}
        logo={<HitachiLogo style={{ width: 72, height: 20 }} />}
        name="Hitachi Visualization Suite"
      />

      {!production && isMdUp && (
        <HvHeaderActions>
          <HvButton
            icon
            aria-label="Change theme"
            onClick={() => toggleTheme()}
          >
            <ThemeSwitcher />
          </HvButton>
          <HvButton icon aria-label="Logout" onClick={() => keycloak?.logout()}>
            {keycloak?.authenticated && <LogOut />}
          </HvButton>
        </HvHeaderActions>
      )}
    </HvHeader>
  );
};

export default Header;
